import React from 'react';
import { IconButtonProps } from 'components/IconButton';
import Avatar from './Avatar';
import * as S from './styles';
import { AvatarProps } from './types';

export interface AvatarButtonProps
  extends Omit<IconButtonProps, 'as' | 'size'>,
    AvatarProps {}

/**
 * A clickable `Avatar`
 */
const AvatarButton = React.forwardRef<HTMLButtonElement, AvatarButtonProps>(
  ({ initial, size, ...props }, ref) => (
    <S.Button ref={ref} {...props}>
      <Avatar {...{ initial, size }} />
    </S.Button>
  ),
);

export default AvatarButton;
